import {useEffect} from 'react';
import {useLocation} from 'react-router';

export const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const currentHash = location.hash.slice(1);
    if (!currentHash) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      const element = document.getElementById(currentHash);
      if (!element) {
        return;
      }

      const top = window.scrollY + element.getBoundingClientRect().top - 60;
      document.body.scrollTo({top, behavior: 'smooth'});
    }, 100);

    return () => window.clearTimeout(timeoutId);
  }, [location]);

  return null;
};
